import classNames from 'classnames';
import React, { useRef } from 'react';
import Icon from '../Icon/icon';

export interface ProjectCardProps {
  title: string;
  author?: string;
  level?: number;
  isCompleted?: boolean;
  imageSrc?: string;
  href?: string;
  target?: string;
  tags?: Array<string>;
}

const ProjectCard = ({
  title,
  author = '코딩엑스AI',
  level = 0,
  isCompleted,
  imageSrc,
  href,
  target,
  tags,
}: ProjectCardProps) => {
  return (
    <a
      className={classNames('project-card', {
        [`level-${level}`]: true,
      })}
      href={href}
      target={target}
    >
      <header className="project-card-header">
        <div className="thumbnail">
          {imageSrc && <img src={imageSrc} alt="" />}
        </div>
      </header>

      <div className="project-card-body">
        <p className="title">{title}</p>

        <div className="level">
          <Icon name="Level" />
          <span>Lv {level}</span>
        </div>

        <ul className="tag-list">
          {tags?.map((tag) => (
            <li className="tag-item" key={tag}>
              {tag}
            </li>
          ))}
        </ul>
      </div>

      <footer className="project-card-footer">
        <small>{author}</small>
        {isCompleted && <Icon className="check-icon" name="Select" />}
      </footer>
    </a>
  );
};

export default ProjectCard;
